import { generatePath } from '@ps/web-core-utils';
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';

import { select } from '@swf/core/store';

import { ClubRoute } from '../../../types/common';

import Results from './Results';
import ResultsListItem from './ResultsListItem/ResultsListItem';

const ResultsContainer: React.FC = () => {
  const { homeGamesClubs = '' } = useSelector(select.cms.getAliases);

  return (
    <Switch>
      <Route
        path={generatePath(homeGamesClubs, {
          clubId: ':clubId',
          section: ClubRoute.Results,
          subsection: ':subsection'
        })}
        component={ResultsListItem}
      />
      <Route
        path={generatePath(homeGamesClubs, {
          clubId: ':clubId',
          section: ClubRoute.Results
        })}
        component={Results}
      />
    </Switch>
  );
};

export default ResultsContainer;
